import { initTheme } from "@/utils/theme";

import { IChannelConfigs, IChannelTheme } from "../types";
import CharlotteFooter from "./components/Layout/Footer.vue";
const theme: IChannelTheme = {};
export default {
  configs: {
    useChannelLogo: true,
    useChannelLanguages: true,
    components: {
      Footer: {
        component: CharlotteFooter
      }
    },
    currency: "local",
    pages: {
      Index: {
        leftLogoUrl:
          "https://qiniu-uploads-cdn.charmdeer.com/uploaded/FrJMgfzPlHPIBpdwFDUolLYeAMRy/LOCKUP.png",
        banners: {
          list: [
            {
              img: "https://qiniu-uploads-cdn.charmdeer.com/uploaded/FhexdAHurUM_0XKA8VisKp7LIiVd/Y_homebanner_web@3x.webp"
            }
          ]
        }
      }
    }
  },
  init() {
    initTheme(theme);
  }
} as IChannelConfigs;
